import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trimStart',
})
export class TrimStartPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.trimStart();
  }
}
